/* PWA — captura do evento de instalação, registro do service worker e detecção
 * de plataforma. Importado cedo no index.js para não perder o
 * `beforeinstallprompt` (que dispara antes de qualquer página montar). */

let deferredPrompt = null;

// Evento custom que a UI escuta para re-renderizar quando o estado muda.
export const PWA_EVENT = "bendesk:pwa-state";
function emit() {
  window.dispatchEvent(new Event(PWA_EVENT));
}

export function initPwa() {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault(); // impede o mini-infobar do Chrome; nós damos o botão
    deferredPrompt = e;
    emit();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    emit();
  });
  registerServiceWorker();
}

function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  // Em dev o CRA não serve /sw.js; registra só em produção (build).
  if (process.env.NODE_ENV !== "production") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// O navegador tem um prompt nativo pronto (Chrome/Edge/Android).
export function canInstall() {
  return deferredPrompt !== null;
}

// Dispara o prompt nativo. Retorna 'accepted' | 'dismissed' | 'unavailable'.
export async function promptInstall() {
  if (!deferredPrompt) return "unavailable";
  await deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  emit();
  return choice.outcome;
}

// App já está rodando instalado (standalone / tela cheia).
export function isStandalone() {
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    navigator.standalone === true // iOS Safari
  );
}

export function isIOS() {
  const ua = navigator.userAgent || "";
  const iOSDevice = /iPad|iPhone|iPod/.test(ua);
  // iPadOS 13+ finge ser Mac; detecta pelo touch.
  const iPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return iOSDevice || iPadOS;
}

export function isAndroid() {
  return /Android/.test(navigator.userAgent || "");
}

// Safari (desktop ou iOS) — não suporta beforeinstallprompt.
export function isSafari() {
  const ua = navigator.userAgent || "";
  return /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
}
